import React, { useState, useRef, useEffect, useCallback } from "react";
import styled, { css } from "styled-components";
import { useMutation } from "@tanstack/react-query";
import { theme } from "../../styles/theme"; // Stelle sicher, dass dieser Pfad korrekt ist
import {
  getSectionPdf,
  getJudgmentPdf,
  pollForSectionPdf,
  checkStatementDerivation,
} from "../../api/analysis";
import { useAnalysisStore } from "../../store/analysisStore";
import { PdfModal } from "../common/Modal";
import Badge from "../common/Badge"; // Assuming Badge is styled appropriately
import { formatFileSize } from "../../utils/formatting"; // Utils Import ist schon da

// Icons (bleiben unverändert)
const Icons = {
  Question: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
      <line x1="12" y1="17" x2="12.01" y2="17"></line>
    </svg>
  ),
  Document: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
      <polyline points="14 2 14 8 20 8"></polyline>
      <line x1="16" y1="13" x2="8" y2="13"></line>
      <line x1="16" y1="17" x2="8" y2="17"></line>
      <polyline points="10 9 9 9 8 9"></polyline>
    </svg>
  ),
  Finding: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="8" y1="6" x2="21" y2="6"></line>
      <line x1="8" y1="12" x2="21" y2="12"></line>
      <line x1="8" y1="18" x2="21" y2="18"></line>
      <line x1="3" y1="6" x2="3.01" y2="6"></line>
      <line x1="3" y1="12" x2="3.01" y2="12"></line>
      <line x1="3" y1="18" x2="3.01" y2="18"></line>
    </svg>
  ),
  Law: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
  ),
  Pattern: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34"></path>
      <path d="M19 4v6h-6"></path>
      <line x1="20" y1="7" x2="12" y2="15"></line>
    </svg>
  ),
  Summary: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
      <line x1="8" y1="12" x2="16" y2="12"></line>
      <line x1="8" y1="8" x2="16" y2="8"></line>
      <line x1="8" y1="16" x2="13" y2="16"></line>
    </svg>
  ),
  Argument: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
    </svg>
  ),
  Conflict: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>
      <line x1="12" y1="8" x2="12" y2="12"></line>
      <line x1="12" y1="16" x2="12.01" y2="16"></line>
    </svg>
  ),
  Conclusion: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M18 8h1a4 4 0 0 1 0 8h-1"></path>
      <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"></path>
      <line x1="6" y1="1" x2="6" y2="4"></line>
      <line x1="10" y1="1" x2="10" y2="4"></line>
      <line x1="14" y1="1" x2="14" y2="4"></line>
    </svg>
  ),
  Files: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
      <polyline points="14 2 14 8 20 8"></polyline>
      <line x1="16" y1="13" x2="8" y2="13"></line>
      <line x1="16" y1="17" x2="8" y2="17"></line>
      <polyline points="10 9 9 9 8 9"></polyline>
    </svg>
  ),
  Judgment: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M2 20h.01"></path>
      <path d="M7 20v-4"></path>
      <path d="M12 20v-8"></path>
      <path d="M17 20V8"></path>
      <path d="M22 4v16"></path>
    </svg>
  ),
  ValidCheck: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke={theme.colors.success} // Use theme color
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
  ),
  Warning: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke={theme.colors.warning} // Use theme color
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="8" x2="12" y2="12"></line>
      <line x1="12" y1="16" x2="12.01" y2="16"></line>
    </svg>
  ),
  Info: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor" // Inherits color from parent
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="16" x2="12" y2="12"></line>
      <line x1="12" y1="8" x2="12.01" y2="8"></line>
    </svg>
  ),
};

// Spinner Komponente (bleibt unverändert)
const ValidationSpinner = () => (
  <SpinnerContainer>
    <Spinner />
  </SpinnerContainer>
);

const SpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
`;

const Spinner = styled.div`
  width: 100%;
  height: 100%;
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top-color: ${theme.colors.primary};
  animation: spin 1s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

// Funktion zum Rendern von Markdown als HTML (bleibt unverändert)
const renderMarkdown = (markdown) => {
  if (!markdown) return null;
  let html = markdown.replace(/^# (.+)$/gm, "<h1>$1</h1>");
  html = html.replace(/^## (.+)$/gm, "<h2>$1</h2>");
  html = html.replace(/^### (.+)$/gm, "<h3>$1</h3>");
  html = html.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
  html = html.replace(/\*(.+?)\*/g, "<em>$1</em>");
  html = html.replace(/^\* (.+)$/gm, "<li>$1</li>");
  html = html.replace(/(<li>.*?<\/li>\s*)+/g, (match) => `<ul>${match}</ul>`);
  html = html.replace(/^\d+\. (.+)$/gm, "<li>$1</li>");
  html = html.replace(
    /<ol>.*?<\/ol>|(<li[^>]*>.*?<\/li>\s*)+/g,
    (match) => {
      if (match.startsWith("<ol>")) return match;
      if (match.startsWith("<li>")) return `<ol>${match}</ol>`;
      return match;
    },
  );
  html = html.replace(
    /^(?![<\s#*0-9.]|<ul>|<ol>|<li>).*$/gm,
    "<p>$&</p>",
  );
  html = html.replace(/<p>(.*?)<\/p>/gs, (match, pContent) => {
    return `<p>${pContent.replace(/\n/g, "<br/>")}</p>`;
  });
  html = html.replace(/<p>\s*<\/p>/g, "");
  html = html.replace(/<(ul|ol)><br\/>/g, "<$1>");
  html = html.replace(/<br\/><\/(ul|ol)>/g, "</$1>");
  html = html.replace(/<li><br\/>/g, "<li>");
  html = html.replace(/<br\/><\/li>/g, "</li>");
  return html;
};

// Hauptkomponente
const AnalysisDisplay = ({ analysis }) => {
  const [isPdfModalOpen, setIsPdfModalOpen] = useState(false);
  const [currentPdfPath, setCurrentPdfPath] = useState(null);
  const [loadingCitations, setLoadingCitations] = useState({});
  const [isUsedDocsOpen, setIsUsedDocsOpen] = useState(false);
  const [isJudgmentsOverviewOpen, setIsJudgmentsOverviewOpen] = useState(false);
  const [activeSection, setActiveSection] = useState(null);
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" && window.innerWidth < 768,
  );
  const [showNav, setShowNav] = useState(!isMobile);

  const [validatingStatements, setValidatingStatements] = useState({});
  const [failedValidations, setFailedValidations] = useState({});
  const storedValidationResults = useAnalysisStore(
    (state) => state.validationResults,
  );
  const setValidationResult = useAnalysisStore(
    (state) => state.setValidationResult,
  );

  const sectionRefs = {
    rechtsfragen: useRef(null),
    grundlagen: useRef(null),
    feststellungen: useRef(null),
    rechtsprechungsSummary: useRef(null),
    rechtsprechung: useRef(null),
    judgmentsOverview: useRef(null),
    argumentationen: useRef(null),
    spannungsfelder: useRef(null),
    schlussfolgerung: useRef(null),
    dokumente: useRef(null),
  };

  const scrollToSection = (sectionKey) => {
    if (sectionRefs[sectionKey] && sectionRefs[sectionKey].current) {
      sectionRefs[sectionKey].current.scrollIntoView({ behavior: "smooth" });
      setActiveSection(sectionKey);
      if (isMobile) {
        setShowNav(false);
      }
    }
  };

  const sectionPdfMutation = useMutation({
    mutationFn: getSectionPdf,
    onSuccess: (data, variables) => {
      if (data.status === "completed" && data.pdfPath) {
        setCurrentPdfPath(data.pdfPath);
        setIsPdfModalOpen(true);
        setLoadingCitations((prev) => {
          const newState = { ...prev };
          delete newState[variables.citation];
          return newState;
        });
      } else if (data.status === "started") {
        pollForSectionPdf(variables.citation, (pdfPath) => {
          setCurrentPdfPath(pdfPath);
          setIsPdfModalOpen(true);
          setLoadingCitations((prev) => {
            const newState = { ...prev };
            delete newState[variables.citation];
            return newState;
          });
        });
      }
    },
    onError: (error, variables) => {
      console.error("Error fetching section PDF:", error);
      setLoadingCitations((prev) => {
        const newState = { ...prev };
        delete newState[variables.citation];
        return newState;
      });
      // Optionally show an error message to the user
    },
  });

  const judgmentPdfMutation = useMutation({
    mutationFn: getJudgmentPdf,
    onSuccess: (data, variables) => {
      if (data.pdfPath) {
        setCurrentPdfPath(data.pdfPath);
        setIsPdfModalOpen(true);
        setLoadingCitations((prev) => {
          const newState = { ...prev };
          delete newState[variables.citation];
          return newState;
        });
      }
    },
    onError: (error, variables) => {
      console.error("Error fetching judgment PDF:", error);
      setLoadingCitations((prev) => {
        const newState = { ...prev };
        delete newState[variables.citation];
        return newState;
      });
      // Optionally show an error message to the user
    },
  });

  const handleCitationClick = (citation) => {
    if (loadingCitations[citation]) {
      return;
    }
    setLoadingCitations((prev) => ({ ...prev, [citation]: true }));
    const isJudgment = citation.match(/OGH|VwGH|VfGH|BVwG|[0-9]+Ob[0-9]+/);
    if (isJudgment) {
      judgmentPdfMutation.mutate({ citation });
    } else {
      sectionPdfMutation.mutate({ citation });
    }
  };

  const renderCitation = (citation, variant = "standard") => {
    const isLoading = loadingCitations[citation];
    const isJudgment = citation.match(/OGH|VwGH|VfGH|BVwG|[0-9]+Ob[0-9]+/);

    return (
      <Citation
        onClick={() => handleCitationClick(citation)}
        disabled={isLoading}
        variant={variant}
        isJudgment={isJudgment}
      >
        {variant === "badge" &&
          (isJudgment ? <Icons.Judgment /> : <Icons.Law />)}
        <span>{citation}</span>
        {isLoading && <LoadingDot />}
      </Citation>
    );
  };

  const handleJudgmentLinkClick = (filepath) => {
    if (filepath) {
      setCurrentPdfPath(filepath);
      setIsPdfModalOpen(true);
    } else {
      console.warn("Kein Dateipfad für Urteilslink vorhanden.");
    }
  };

  const validationMutation = useMutation({
    mutationFn: (validationData) => checkStatementDerivation(validationData),
    onSuccess: (data, { statement }) => {
      setValidationResult(statement, data.canBeDerived);
      setValidatingStatements((prev) => {
        const newState = { ...prev };
        delete newState[statement];
        return newState;
      });
    },
    onError: (error, { statement }) => {
      console.error("Error validating statement:", error);
      setFailedValidations((prev) => ({
        ...prev,
        [statement]: true,
      }));
      setValidatingStatements((prev) => {
        const newState = { ...prev };
        delete newState[statement];
        return newState;
      });
    },
  });

  const findJudgmentPath = useCallback(
    (urteilsId) => {
      let foundDoc = null;
      if (analysis?.usedDocuments?.judgments) {
        const searchVariants = [
          urteilsId,
          urteilsId.replace(/\s/g, "_"),
          urteilsId.replace(/\//g, "-"),
          urteilsId.replace(/\s/g, "_").replace(/\//g, "-"),
        ];
        for (const doc of analysis.usedDocuments.judgments) {
          for (const variant of searchVariants) {
            // More robust check: ensure variant is a whole part of the filename
            const regex = new RegExp(`(^|[_\\/-])${variant}(?=[_\\/-]|\\.pdf$)`);
            if (regex.test(doc.filename)) {
              foundDoc = doc;
              break;
            }
          }
          if (foundDoc) break;
        }
      }
      if (!foundDoc && analysis?.sortedJudgments) {
        const sortedMatch = analysis.sortedJudgments.find((j) => {
          const filename = j.filepath.split(/[\\/]/).pop();
          const regex = new RegExp(`(^|[_\\/-])${urteilsId.replace(/\s/g, "_").replace(/\//g, "-")}(?=[_\\/-]|\\.pdf$)`);
          return regex.test(filename);
        });
        if (sortedMatch) {
          return sortedMatch.filepath;
        }
      }
      if (!foundDoc) {
        // console.log(`Konnte kein PDF für Urteil ${urteilsId} finden`);
      }
      return foundDoc ? foundDoc.path : null;
    },
    [analysis],
  );

  const validateStatement = useCallback(
    (statement) => {
      if (
        storedValidationResults[statement.Text] !== undefined ||
        validatingStatements[statement.Text] ||
        failedValidations[statement.Text]
      ) {
        return;
      }
      if (!statement.Urteile || statement.Urteile.length === 0) {
        return;
      }
      const pdfPaths = statement.Urteile.map((urteil) => {
        const urteilsId = urteil.trim();
        return findJudgmentPath(urteilsId);
      }).filter(Boolean);
      if (pdfPaths.length === 0) {
        setFailedValidations((prev) => ({ ...prev, [statement.Text]: true }));
        return;
      }
      setValidatingStatements((prev) => ({ ...prev, [statement.Text]: true }));
      validationMutation.mutate({
        statement: statement.Text,
        pdfPaths: pdfPaths,
      });
    },
    [
      validationMutation,
      storedValidationResults,
      validatingStatements,
      failedValidations,
      findJudgmentPath,
    ],
  );

  const validatePattern = useCallback(
    (pattern) => {
      if (
        storedValidationResults[pattern.Muster_Beschreibung] !== undefined ||
        validatingStatements[pattern.Muster_Beschreibung] ||
        failedValidations[pattern.Muster_Beschreibung]
      ) {
        return;
      }
      if (
        !pattern.Belegende_Urteile ||
        pattern.Belegende_Urteile.length === 0
      ) {
        return;
      }
      const pdfPaths = pattern.Belegende_Urteile.map((urteil) => {
        const urteilsId = urteil.trim();
        return findJudgmentPath(urteilsId);
      }).filter(Boolean);
      if (pdfPaths.length === 0) {
        setFailedValidations((prev) => ({
          ...prev,
          [pattern.Muster_Beschreibung]: true,
        }));
        return;
      }
      setValidatingStatements((prev) => ({
        ...prev,
        [pattern.Muster_Beschreibung]: true,
      }));
      validationMutation.mutate({
        statement: pattern.Muster_Beschreibung,
        pdfPaths: pdfPaths,
      });
    },
    [
      validationMutation,
      storedValidationResults,
      validatingStatements,
      failedValidations,
      findJudgmentPath,
    ],
  );

  const ValidationStatus = ({ text }) => {
    if (validatingStatements[text]) {
      return (
        <ValidationStatusIcon className="validation-loading">
          <ValidationSpinner />
        </ValidationStatusIcon>
      );
    } else if (storedValidationResults[text] === true) {
      return (
        <ValidationStatusIcon className="validation-success">
          <Icons.ValidCheck />
        </ValidationStatusIcon>
      );
    } else if (storedValidationResults[text] === false) {
      return (
        <ValidationStatusIcon className="validation-warning">
          <Icons.Warning />
        </ValidationStatusIcon>
      );
    }
    return null;
  };

  useEffect(() => {
    const handleScroll = () => {
      if (typeof window === "undefined") return;
      const scrollPosition = window.scrollY + 150;
      let currentSection = null;
      const visibleSections = navItems.map((item) => item.id); // Only check visible sections

      visibleSections.forEach((key) => {
        const ref = sectionRefs[key];
        if (
          ref &&
          ref.current &&
          ref.current.offsetTop <= scrollPosition &&
          ref.current.offsetTop + ref.current.offsetHeight > scrollPosition
        ) {
          currentSection = key;
        }
      });
      // Fallback: if no section is active but we scrolled down, activate the last visible one
      if (
        !currentSection &&
        window.scrollY + window.innerHeight >= document.body.offsetHeight - 50
      ) {
        currentSection = visibleSections[visibleSections.length - 1];
      }
      // Fallback: if no section is active and we are at the top, activate the first visible one
      else if (!currentSection && window.scrollY < 150) {
        currentSection = visibleSections[0];
      }

      setActiveSection(currentSection);
    };

    const handleResize = () => {
      if (typeof window === "undefined") return;
      const newIsMobile = window.innerWidth < 768;
      if (newIsMobile !== isMobile) {
        setIsMobile(newIsMobile);
        setShowNav(!newIsMobile); // Hide nav on mobile initially, show on desktop
      }
    };

    if (typeof window !== "undefined") {
      window.addEventListener("scroll", handleScroll, { passive: true });
      window.addEventListener("resize", handleResize);
      handleScroll(); // Initial check
      handleResize(); // Initial check
    }

    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("scroll", handleScroll);
        window.removeEventListener("resize", handleResize);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile, analysis]); // Re-run if analysis changes (navItems might change)

  useEffect(() => {
    if (analysis) {
      if (analysis.Feststellungen && analysis.Feststellungen.length > 0) {
        analysis.Feststellungen.forEach((statement) => {
          validateStatement(statement);
        });
      }
      if (
        analysis.Analyse_Rechtsprechungsmuster &&
        analysis.Analyse_Rechtsprechungsmuster.length > 0
      ) {
        analysis.Analyse_Rechtsprechungsmuster.forEach((pattern) => {
          validatePattern(pattern);
        });
      }
    }
  }, [analysis, validateStatement, validatePattern]);

  // Erstellen der Navigations-Items basierend auf den Daten (aktualisiert)
  const navItems = React.useMemo(() => {
    if (!analysis) return [];
    return [
      {
        id: "rechtsfragen",
        title: "Rechtsfragen",
        icon: <Icons.Question />,
        visible:
          analysis.Zentrale_Rechtsfragen &&
          analysis.Zentrale_Rechtsfragen.length > 0,
      },
      {
        id: "grundlagen",
        title: "Gesetzliche Grundlagen",
        icon: <Icons.Document />,
        visible: !!analysis.Gesetzliche_Grundlagen_Zusammenfassung,
      },
      {
        id: "feststellungen",
        title: "Feststellungen",
        icon: <Icons.Finding />,
        visible: analysis.Feststellungen && analysis.Feststellungen.length > 0,
      },
      {
        id: "rechtsprechungsSummary",
        title: "Zsf. Rechtsprechung",
        icon: <Icons.Summary />,
        visible: !!analysis.combinedJudgmentAnalysis,
      },
      {
        id: "rechtsprechung",
        title: "Rechtsprechungsmuster",
        icon: <Icons.Pattern />,
        visible:
          analysis.Analyse_Rechtsprechungsmuster &&
          analysis.Analyse_Rechtsprechungsmuster.length > 0,
      },
      {
        id: "judgmentsOverview",
        title: "Übersicht Urteile",
        icon: <Icons.Judgment />,
        visible:
          analysis.sortedJudgments && analysis.sortedJudgments.length > 0,
      },
      {
        id: "argumentationen",
        title: "Argumentationslinien",
        icon: <Icons.Argument />,
        visible:
          analysis.Potenzielle_Argumentationslinien &&
          analysis.Potenzielle_Argumentationslinien.length > 0,
      },
      {
        id: "spannungsfelder",
        title: "Spannungsfelder",
        icon: <Icons.Conflict />,
        visible:
          analysis.Identifizierte_Spannungsfelder_Widersprueche &&
          analysis.Identifizierte_Spannungsfelder_Widersprueche.length > 0,
      },
      {
        id: "schlussfolgerung",
        title: "Schlussfolgerung",
        icon: <Icons.Conclusion />,
        visible: !!analysis.Synthese_Schlussfolgerung,
      },
      {
        id: "dokumente",
        title: "Verwendete Dokumente",
        icon: <Icons.Files />,
        visible: !!analysis.usedDocuments,
      },
    ].filter((item) => item.visible);
  }, [analysis]);

  if (!analysis) {
    return <EmptyState>Keine Analyse verfügbar</EmptyState>;
  }

  return (
    <FlexContainer>
      {/* Navigation */}
      <NavToggle onClick={() => setShowNav(!showNav)}>
        {showNav ? "‹" : "›"}
      </NavToggle>

      {showNav && (
        <Navigation>
          <NavTitle>Inhaltsübersicht</NavTitle>
          <NavList>
            {navItems.map((item) => (
              <NavItem
                key={item.id}
                active={activeSection === item.id}
                onClick={() => scrollToSection(item.id)}
              >
                <NavIcon>{item.icon}</NavIcon>
                <NavText>{item.title}</NavText>
              </NavItem>
            ))}
          </NavList>
        </Navigation>
      )}

      {/* Hauptinhalt */}
      <MainContent $navVisible={showNav}>
        <StyledTitle>{analysis.Thema || "Rechtliche Analyse"}</StyledTitle>

        <DisclaimerBanner>
          <DisclaimerIcon>
            <Icons.Info />
          </DisclaimerIcon>
          <DisclaimerText>
            <strong>Wichtiger Hinweis:</strong> KI-Ergebnisse können Fehler
            enthalten ('Halluzinationen'). Überprüfen Sie alle Informationen
            sorgfältig. Dies ist keine Rechtsberatung, keine Haftung für
            Richtigkeit.
          </DisclaimerText>
        </DisclaimerBanner>

        {/* Sections */}
        {navItems.map((item) => {
          const sectionId = item.id;
          const sectionRef = sectionRefs[sectionId];
          if (!sectionRef) return null; // Should not happen if navItems are correct

          switch (sectionId) {
            case "rechtsfragen":
              return (
                <StyledSection
                  key={sectionId}
                  ref={sectionRef}
                  id={sectionId}
                >
                  <SectionHeader>
                    <SectionIcon>
                      <Icons.Question />
                    </SectionIcon>
                    <SectionTitle>Zentrale Rechtsfragen</SectionTitle>
                  </SectionHeader>
                  <Card>
                    <NumberedList>
                      {analysis.Zentrale_Rechtsfragen.map((question, index) => (
                        <ListItem key={index}>{question}</ListItem>
                      ))}
                    </NumberedList>
                  </Card>
                </StyledSection>
              );
            case "grundlagen":
              return (
                <StyledSection
                  key={sectionId}
                  ref={sectionRef}
                  id={sectionId}
                >
                  <SectionHeader>
                    <SectionIcon>
                      <Icons.Document />
                    </SectionIcon>
                    <SectionTitle>Gesetzliche Grundlagen</SectionTitle>
                  </SectionHeader>
                  <Card>
                    <Paragraph>
                      {analysis.Gesetzliche_Grundlagen_Zusammenfassung}
                    </Paragraph>
                  </Card>
                </StyledSection>
              );
            case "feststellungen":
              return (
                <StyledSection
                  key={sectionId}
                  ref={sectionRef}
                  id={sectionId}
                >
                  <SectionHeader>
                    <SectionIcon>
                      <Icons.Finding />
                    </SectionIcon>
                    <SectionTitle>Feststellungen</SectionTitle>
                  </SectionHeader>
                  {analysis.Feststellungen.map((item, index) => (
                    <FindingCard key={index}>
                      <StatementHeader>
                        <ValidationStatus text={item.Text} />
                        <FindingText>{item.Text}</FindingText>
                      </StatementHeader>
                      <CitationContainer>
                        {item.Gesetzesstellen &&
                          item.Gesetzesstellen.length > 0 && (
                            <CitationList>
                              <CitationLabel>
                                <Icons.Law /> Gesetzesstellen:
                              </CitationLabel>
                              <BadgeContainer>
                                {item.Gesetzesstellen.map((citation, i) => (
                                  <span key={i}>
                                    {renderCitation(citation, "badge")}
                                  </span>
                                ))}
                              </BadgeContainer>
                            </CitationList>
                          )}
                        {item.Urteile && item.Urteile.length > 0 && (
                          <CitationList>
                            <CitationLabel>
                              <Icons.Judgment /> Urteile:
                            </CitationLabel>
                            <BadgeContainer>
                              {item.Urteile.map((citation, i) => (
                                <span key={i}>
                                  {renderCitation(citation, "badge")}
                                </span>
                              ))}
                            </BadgeContainer>
                          </CitationList>
                        )}
                      </CitationContainer>
                    </FindingCard>
                  ))}
                </StyledSection>
              );
            case "rechtsprechungsSummary":
              return (
                <StyledSection
                  key={sectionId}
                  ref={sectionRef}
                  id={sectionId}
                >
                  <SectionHeader>
                    <SectionIcon>
                      <Icons.Summary />
                    </SectionIcon>
                    <SectionTitle>
                      Zusammenfassung der Rechtsprechung
                    </SectionTitle>
                  </SectionHeader>
                  <SummaryCard>
                    <MarkdownContent
                      dangerouslySetInnerHTML={{
                        __html: renderMarkdown(
                          analysis.combinedJudgmentAnalysis,
                        ),
                      }}
                    />
                  </SummaryCard>
                </StyledSection>
              );
            case "rechtsprechung":
              return (
                <StyledSection
                  key={sectionId}
                  ref={sectionRef}
                  id={sectionId}
                >
                  <SectionHeader>
                    <SectionIcon>
                      <Icons.Pattern />
                    </SectionIcon>
                    <SectionTitle>
                      Analyse der Rechtsprechungsmuster
                    </SectionTitle>
                  </SectionHeader>
                  {analysis.Analyse_Rechtsprechungsmuster.map(
                    (pattern, index) => (
                      <PatternCard key={index}>
                        <StatementHeader>
                          <ValidationStatus
                            text={pattern.Muster_Beschreibung}
                          />
                          <PatternDescription>
                            {pattern.Muster_Beschreibung}
                          </PatternDescription>
                        </StatementHeader>
                        <CitationContainer>
                          {pattern.Belegende_Urteile &&
                            pattern.Belegende_Urteile.length > 0 && (
                              <CitationList>
                                <CitationLabel>
                                  <Icons.Judgment /> Belegende Urteile:
                                </CitationLabel>
                                <BadgeContainer>
                                  {pattern.Belegende_Urteile.map(
                                    (citation, i) => (
                                      <span key={i}>
                                        {renderCitation(citation, "badge")}
                                      </span>
                                    ),
                                  )}
                                </BadgeContainer>
                              </CitationList>
                            )}
                          {pattern.Relevante_Gesetzesbezüge &&
                            pattern.Relevante_Gesetzesbezüge.length > 0 && (
                              <CitationList>
                                <CitationLabel>
                                  <Icons.Law /> Relevante Gesetzesbezüge:
                                </CitationLabel>
                                <BadgeContainer>
                                  {pattern.Relevante_Gesetzesbezüge.map(
                                    (citation, i) => (
                                      <span key={i}>
                                        {renderCitation(citation, "badge")}
                                      </span>
                                    ),
                                  )}
                                </BadgeContainer>
                              </CitationList>
                            )}
                        </CitationContainer>
                      </PatternCard>
                    ),
                  )}
                </StyledSection>
              );
            case "judgmentsOverview":
              return (
                <StyledSection
                  key={sectionId}
                  ref={sectionRef}
                  id={sectionId}
                >
                  <CollapsibleSection>
                    <CollapsibleHeader
                      onClick={() =>
                        setIsJudgmentsOverviewOpen(!isJudgmentsOverviewOpen)
                      }
                      isOpen={isJudgmentsOverviewOpen}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <SectionIcon>
                          <Icons.Judgment />
                        </SectionIcon>
                        <SectionTitle>
                          Übersicht zu den Urteilen (
                          {analysis.sortedJudgments.length})
                        </SectionTitle>
                      </div>
                      <CollapseIcon isOpen={isJudgmentsOverviewOpen}>
                        ▼
                      </CollapseIcon>
                    </CollapsibleHeader>

                    {isJudgmentsOverviewOpen && (
                      <JudgmentsOverviewContent>
                        <JudgmentList>
                          {analysis.sortedJudgments.map((judgment, index) => (
                            <JudgmentListItem key={index}>
                              <JudgmentHeader>
                                <JudgmentLink
                                  onClick={() =>
                                    handleJudgmentLinkClick(judgment.filepath)
                                  }
                                >
                                  {judgment.filepath.split(/[\\/]/).pop()}
                                </JudgmentLink>
                                <JudgmentRating rating={judgment.rating}>
                                  {judgment.rating}/100 Relevanz
                                </JudgmentRating>
                              </JudgmentHeader>
                              <JudgmentSummary>
                                {judgment.zusammenfassung}
                              </JudgmentSummary>
                            </JudgmentListItem>
                          ))}
                        </JudgmentList>
                      </JudgmentsOverviewContent>
                    )}
                  </CollapsibleSection>
                </StyledSection>
              );
            case "argumentationen":
              return (
                <StyledSection
                  key={sectionId}
                  ref={sectionRef}
                  id={sectionId}
                >
                  <SectionHeader>
                    <SectionIcon>
                      <Icons.Argument />
                    </SectionIcon>
                    <SectionTitle>Potenzielle Argumentationslinien</SectionTitle>
                  </SectionHeader>
                  <ArgumentContainer>
                    {analysis.Potenzielle_Argumentationslinien.map(
                      (argument, index) => (
                        <ArgumentCard key={index} position={argument.Position}>
                          <ArgumentHeader>
                            <ArgumentPosition>
                              {argument.Position}
                            </ArgumentPosition>
                          </ArgumentHeader>
                          <ArgumentContent>{argument.Argument}</ArgumentContent>
                          {argument.Stuetzende_Quellen &&
                            argument.Stuetzende_Quellen.length > 0 && (
                              <CitationList>
                                <CitationLabel>
                                  Stützende Quellen:
                                </CitationLabel>
                                <BadgeContainer>
                                  {argument.Stuetzende_Quellen.map(
                                    (citation, i) => (
                                      <span key={i}>
                                        {renderCitation(citation, "badge")}
                                      </span>
                                    ),
                                  )}
                                </BadgeContainer>
                              </CitationList>
                            )}
                        </ArgumentCard>
                      ),
                    )}
                  </ArgumentContainer>
                </StyledSection>
              );
            case "spannungsfelder":
              return (
                <StyledSection
                  key={sectionId}
                  ref={sectionRef}
                  id={sectionId}
                >
                  <SectionHeader>
                    <SectionIcon>
                      <Icons.Conflict />
                    </SectionIcon>
                    <SectionTitle>
                      Identifizierte Spannungsfelder und Widersprüche
                    </SectionTitle>
                  </SectionHeader>
                  {analysis.Identifizierte_Spannungsfelder_Widersprueche.map(
                    (conflict, index) => (
                      <ConflictCard key={index}>
                        <ConflictDescription>
                          {conflict.Beschreibung_Konflikt}
                        </ConflictDescription>
                        {conflict.Betroffene_Quellen &&
                          conflict.Betroffene_Quellen.length > 0 && (
                            <CitationList>
                              <CitationLabel>Betroffene Quellen:</CitationLabel>
                              <BadgeContainer>
                                {conflict.Betroffene_Quellen.map(
                                  (citation, i) => (
                                    <span key={i}>
                                      {renderCitation(citation, "badge")}
                                    </span>
                                  ),
                                )}
                              </BadgeContainer>
                            </CitationList>
                          )}
                      </ConflictCard>
                    ),
                  )}
                </StyledSection>
              );
            case "schlussfolgerung":
              return (
                <StyledSection
                  key={sectionId}
                  ref={sectionRef}
                  id={sectionId}
                >
                  <SectionHeader>
                    <SectionIcon>
                      <Icons.Conclusion />
                    </SectionIcon>
                    <SectionTitle>Synthese und Schlussfolgerung</SectionTitle>
                  </SectionHeader>
                  <ConclusionCard>
                    <Paragraph>{analysis.Synthese_Schlussfolgerung}</Paragraph>
                  </ConclusionCard>
                </StyledSection>
              );
            case "dokumente":
              return (
                <StyledSection
                  key={sectionId}
                  ref={sectionRef}
                  id={sectionId}
                >
                  <CollapsibleSection>
                    <CollapsibleHeader
                      onClick={() => setIsUsedDocsOpen(!isUsedDocsOpen)}
                      isOpen={isUsedDocsOpen}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <SectionIcon>
                          <Icons.Files />
                        </SectionIcon>
                        <SectionTitle>Verwendete Dokumente</SectionTitle>
                      </div>
                      <CollapseIcon isOpen={isUsedDocsOpen}>▼</CollapseIcon>
                    </CollapsibleHeader>

                    {isUsedDocsOpen && (
                      <UsedDocumentsContent>
                        <DocInfoBanner>
                          {analysis.usedDocuments.total && (
                            <span>
                              Insgesamt verwendet:{" "}
                              <strong>
                                {analysis.usedDocuments.total.used}
                              </strong>{" "}
                              von {analysis.usedDocuments.total.original}{" "}
                              Dokumenten
                            </span>
                          )}
                        </DocInfoBanner>

                        <DocumentTable>
                          <DocTableHeader>
                            <DocTableRow>
                              <DocTableHeaderCell style={{ width: "40px" }}>
                                #
                              </DocTableHeaderCell>
                              <DocTableHeaderCell>Dokument</DocTableHeaderCell>
                              <DocTableHeaderCell style={{ width: "120px" }}>
                                Größe
                              </DocTableHeaderCell>
                            </DocTableRow>
                          </DocTableHeader>

                          {analysis.usedDocuments.laws &&
                            analysis.usedDocuments.laws.length > 0 && (
                              <DocTableBody>
                                <DocTableCategoryRow>
                                  <DocTableCell colSpan={3}>
                                    <CategoryIcon>
                                      <Icons.Law />
                                    </CategoryIcon>{" "}
                                    Gesetze (
                                    {analysis.usedDocuments.laws.length})
                                  </DocTableCell>
                                </DocTableCategoryRow>
                                {analysis.usedDocuments.laws.map(
                                  (doc, index) => (
                                    <DocTableRow key={`law-${index}`}>
                                      <DocTableCell style={{ width: "40px" }}>
                                        {index + 1}
                                      </DocTableCell>
                                      <DocTableCell>
                                        <DocName
                                          onClick={() => {
                                            if (doc.url) {
                                              setCurrentPdfPath(doc.path);
                                              setIsPdfModalOpen(true);
                                            }
                                          }}
                                          clickable={!!doc.url}
                                        >
                                          {doc.filename}
                                        </DocName>
                                      </DocTableCell>
                                      <DocTableCell style={{ width: "120px" }}>
                                        {formatFileSize(doc.size)}
                                      </DocTableCell>
                                    </DocTableRow>
                                  ),
                                )}
                              </DocTableBody>
                            )}

                          {analysis.usedDocuments.judgments &&
                            analysis.usedDocuments.judgments.length > 0 && (
                              <DocTableBody>
                                <DocTableCategoryRow>
                                  <DocTableCell colSpan={3}>
                                    <CategoryIcon>
                                      <Icons.Judgment />
                                    </CategoryIcon>{" "}
                                    Urteile (
                                    {analysis.usedDocuments.judgments.length})
                                  </DocTableCell>
                                </DocTableCategoryRow>
                                {analysis.usedDocuments.judgments.map(
                                  (doc, index) => (
                                    <DocTableRow key={`judgment-${index}`}>
                                      <DocTableCell style={{ width: "40px" }}>
                                        {index + 1}
                                      </DocTableCell>
                                      <DocTableCell>
                                        <DocName
                                          onClick={() => {
                                            if (doc.url) {
                                              setCurrentPdfPath(doc.path);
                                              setIsPdfModalOpen(true);
                                            }
                                          }}
                                          clickable={!!doc.url}
                                        >
                                          {doc.filename}
                                        </DocName>
                                        {doc.rating !== undefined && (
                                          <DocMetaInfo>
                                            <JudgmentRating
                                              rating={doc.rating}
                                              isInline={true}
                                            >
                                              {doc.rating}/100
                                            </JudgmentRating>
                                            {doc.zusammenfassung && (
                                              <span>
                                                {" "}
                                                - {doc.zusammenfassung}
                                              </span>
                                            )}
                                          </DocMetaInfo>
                                        )}
                                      </DocTableCell>
                                      <DocTableCell style={{ width: "120px" }}>
                                        {formatFileSize(doc.size)}
                                      </DocTableCell>
                                    </DocTableRow>
                                  ),
                                )}
                              </DocTableBody>
                            )}
                        </DocumentTable>

                        {analysis.usedDocuments.removedDocs &&
                          analysis.usedDocuments.removedDocs.length > 0 && (
                            <DocRemovedInfo>
                              <strong>
                                {analysis.usedDocuments.removedDocs.length}{" "}
                                Dokumente
                              </strong>{" "}
                              konnten wegen Größenbeschränkungen nicht
                              berücksichtigt werden.
                            </DocRemovedInfo>
                          )}
                      </UsedDocumentsContent>
                    )}
                  </CollapsibleSection>
                </StyledSection>
              );
            default:
              return null;
          }
        })}
      </MainContent>

      {/* PDF Modal */}
      <PdfModal
        isOpen={isPdfModalOpen}
        onClose={() => setIsPdfModalOpen(false)}
        pdfPath={currentPdfPath}
      />
    </FlexContainer>
  );
};

// --- Styled Components (aktualisiert mit boxShadow Korrektur) ---

const getRatingColor = (rating) => {
  if (rating === undefined || rating === null) return theme.colors.textLight;
  if (rating >= 75) return theme.colors.success; // Use theme success color
  if (rating >= 50) return theme.colors.warning; // Use theme warning color
  if (rating >= 25) return "#e67e22"; // Carrot Orange (kann auch ins Theme)
  return theme.colors.danger; // Use theme danger color
};

const FlexContainer = styled.div`
  display: flex;
  width: 100%;
  position: relative;
  background-color: ${theme.colors.background};
`;

const NavToggle = styled.button`
  position: fixed;
  top: 80px;
  left: 0;
  z-index: 1001;
  background-color: ${theme.colors.primary};
  color: white;
  border: none;
  border-radius: 0 6px 6px 0;
  width: 30px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: ${theme.boxShadow.md}; /* KORRIGIERT */
  transition: background-color ${theme.transitions.fast};
  font-size: 1.2rem;

  &:hover {
    background-color: ${theme.colors.primaryHover}; /* KORRIGIERT */
  }

  @media (min-width: ${theme.breakpoints.md}) {
    /* KORRIGIERT */
    display: none;
  }
`;

const Navigation = styled.aside`
  width: 280px;
  position: sticky;
  top: 60px;
  height: calc(100vh - 60px);
  overflow-y: auto;
  padding: ${theme.spacing.lg} ${theme.spacing.md}; /* KORRIGIERT */
  background-color: ${theme.colors.backgroundAlt};
  border-right: 1px solid ${theme.colors.border};
  z-index: 1000;
  transition: transform 0.3s ease-in-out;

  @media (max-width: ${theme.breakpoints.md}) {
    /* KORRIGIERT */
    position: fixed;
    left: 0;
    top: 0;
    height: 100vh;
    transform: translateX(0);
    box-shadow: ${theme.boxShadow.lg}; /* KORRIGIERT */
  }
`;

const NavTitle = styled.div`
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: ${theme.spacing.lg}; /* KORRIGIERT */
  padding: 0 0.5rem ${theme.spacing.md} 0.5rem; /* KORRIGIERT */
  border-bottom: 1px solid ${theme.colors.border};
  color: ${theme.colors.heading};
`;

const NavList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const NavItem = styled.li`
  margin-bottom: ${theme.spacing.sm}; /* KORRIGIERT */
  padding: 0.75rem 1rem;
  border-radius: ${theme.borderRadius.md};
  cursor: pointer;
  transition: all ${theme.transitions.fast};
  display: flex;
  align-items: center;
  background-color: ${({ active }) =>
    active ? theme.colors.primary + "20" : "transparent"};
  border-left: 4px solid
    ${({ active }) => (active ? theme.colors.primary : "transparent")};
  color: ${({ active }) =>
    active ? theme.colors.primary : theme.colors.text};

  &:hover {
    background-color: ${({ active }) =>
      active
        ? theme.colors.primary + "30"
        : theme.colors.border + "40"};
    color: ${theme.colors.primary};
  }
`;

const NavIcon = styled.span`
  display: flex;
  align-items: center;
  margin-right: ${theme.spacing.md}; /* KORRIGIERT */
  color: inherit;
  transition: color ${theme.transitions.fast};
`;

const NavText = styled.span`
  font-size: 0.95rem;
  font-weight: 500;
  color: inherit;
`;

const MainContent = styled.div`
  flex: 1;
  padding: ${theme.spacing.xl} ${theme.spacing.xl}; /* KORRIGIERT */
  max-width: 100%;
  margin-left: 0;
  transition: margin-left 0.3s ease-in-out, max-width 0.3s ease-in-out;

  @media (min-width: ${theme.breakpoints.md}) {
    /* KORRIGIERT */
    max-width: ${({ $navVisible }) =>
      $navVisible ? "calc(100% - 280px)" : "100%"};
  }

  @media (max-width: ${theme.breakpoints.md}) {
    /* KORRIGIERT */
    padding: ${theme.spacing.lg}; /* KORRIGIERT */
  }
`;

const StyledTitle = styled.h2`
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: ${theme.spacing.lg}; /* KORRIGIERT */
  color: ${theme.colors.heading};
  padding-bottom: ${theme.spacing.md}; /* KORRIGIERT */
  border-bottom: 2px solid ${theme.colors.primary};
`;

const DisclaimerBanner = styled.div`
  background-color: ${theme.colors.warningBackground};
  border: 1px solid ${theme.colors.warningBorder};
  color: ${theme.colors.warningText};
  padding: ${theme.spacing.md} ${theme.spacing.lg}; /* KORRIGIERT */
  border-radius: ${theme.borderRadius.md};
  margin-bottom: ${theme.spacing.xl}; /* KORRIGIERT */
  display: flex;
  align-items: flex-start;
  gap: ${theme.spacing.md}; /* KORRIGIERT */
`;

const DisclaimerIcon = styled.div`
  flex-shrink: 0;
  margin-top: 2px;
  color: ${theme.colors.warning};
`;

const DisclaimerText = styled.p`
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.5;
  strong {
    font-weight: 600;
  }
`;

const StyledSection = styled.section`
  margin-bottom: ${theme.spacing.xxl}; /* KORRIGIERT */
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${theme.spacing.lg}; /* KORRIGIERT */
  padding-bottom: 0.75rem;
  border-bottom: 1px solid ${theme.colors.borderLight};
`;

const SectionIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  margin-right: ${theme.spacing.md}; /* KORRIGIERT */
  border-radius: 50%;
  background-color: ${theme.colors.primary}15;
  color: ${theme.colors.primary};
`;

const SectionTitle = styled.h3`
  font-size: 1.4rem;
  font-weight: 600;
  margin: 0;
  color: ${theme.colors.heading};
`;

const Card = styled.div`
  background-color: white;
  border-radius: ${theme.borderRadius.lg};
  padding: 1.75rem;
  margin-bottom: 1.25rem;
  box-shadow: ${theme.boxShadow.sm}; /* KORRIGIERT */
  border: 1px solid ${theme.colors.borderLight};
`;

const FindingCard = styled(Card)`
  border-left: 5px solid #3498db;
`;

const PatternCard = styled(Card)`
  border-left: 5px solid #2ecc71;
`;

const SummaryCard = styled(Card)`
  border-left: 5px solid ${theme.colors.warning}; /* KORRIGIERT */
  background-color: ${theme.colors.warningBackground}; /* KORRIGIERT */
`;

const ArgumentCard = styled(Card)`
  border-left: 5px solid
    ${({ position }) => {
      if (position === "Antragsteller") return "#9b59b6";
      if (position === "Behörde") return "#e67e22";
      return "#7f8c8d";
    }};
`;

const ConflictCard = styled(Card)`
  border-left: 5px solid ${theme.colors.danger}; /* KORRIGIERT */
`;

const ConclusionCard = styled(Card)`
  border-left: 5px solid #1abc9c;
  background-color: #f8fefd;
`;

const StatementHeader = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 0.75rem;
  gap: 0.75rem;
`;

const ValidationStatusIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 3px;
  flex-shrink: 0;

  &.validation-success svg {
    color: ${theme.colors.success};
  }

  &.validation-warning svg {
    color: ${theme.colors.warning};
  }
`;

const FindingText = styled.div`
  line-height: 1.7;
  font-size: 1rem;
`;

const PatternDescription = styled.div`
  line-height: 1.7;
  font-size: 1rem;
`;

const ConflictDescription = styled.div`
  margin-bottom: 1.25rem;
  line-height: 1.7;
  font-size: 1rem;
`;

const ArgumentContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: ${theme.spacing.lg}; /* KORRIGIERT */

  @media (max-width: ${theme.breakpoints.md}) {
    /* KORRIGIERT */
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
  }
`;

const ArgumentHeader = styled.div`
  margin-bottom: ${theme.spacing.md}; /* KORRIGIERT */
  padding-bottom: ${theme.spacing.md}; /* KORRIGIERT */
  border-bottom: 1px solid ${theme.colors.borderLight};
`;

const ArgumentPosition = styled.div`
  font-weight: 700;
  font-size: 1.05rem;
  color: ${theme.colors.heading};
`;

const ArgumentContent = styled.div`
  margin-bottom: 1.25rem;
  line-height: 1.7;
  font-size: 0.95rem;
`;

const CitationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.md}; /* KORRIGIERT */
  margin-top: 1.25rem;
  padding-top: ${theme.spacing.md}; /* KORRIGIERT */
  border-top: 1px dashed ${theme.colors.borderLight};
`;

const CitationList = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 0.75rem 0.5rem;

  @media (max-width: ${theme.breakpoints.md}) {
    /* KORRIGIERT */
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }
`;

const BadgeContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${theme.spacing.sm}; /* KORRIGIERT */
`;

const CitationLabel = styled.div`
  font-size: 0.9rem;
  font-weight: 600;
  color: ${theme.colors.textLight};
  display: flex;
  align-items: center;
  gap: 0.6rem;
  white-space: nowrap;
  margin-right: ${theme.spacing.sm}; /* KORRIGIERT */
`;

const Citation = styled.button`
  background-color: ${({ isJudgment, variant }) => {
    if (variant === "badge") {
      return isJudgment ? theme.colors.warning + "20" : theme.colors.info + "20";
    }
    return theme.colors.primary + "15";
  }};
  color: ${({ isJudgment, variant }) => {
    if (variant === "badge") {
      return isJudgment ? theme.colors.warningDark : theme.colors.infoDark;
    }
    return theme.colors.primary;
  }};
  border: 1px solid
    ${({ isJudgment, variant }) => {
      if (variant === "badge") {
        return isJudgment ? theme.colors.warning + "50" : theme.colors.info + "50";
      }
      return theme.colors.primary + "40";
    }};
  border-radius: ${theme.borderRadius.sm};
  padding: ${({ variant }) =>
    variant === "badge" ? "0.35rem 0.6rem" : "0.3rem 0.6rem"};
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: all ${theme.transitions.fast};
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  margin: 0;

  &:hover:not(:disabled) {
    background-color: ${({ isJudgment, variant }) => {
      if (variant === "badge") {
        return isJudgment ? theme.colors.warning + "35" : theme.colors.info + "35";
      }
      return theme.colors.primary + "25";
    }};
    border-color: ${({ isJudgment, variant }) => {
      if (variant === "badge") {
        return isJudgment ? theme.colors.warning + "70" : theme.colors.info + "70";
      }
      return theme.colors.primary + "60";
    }};
    transform: translateY(-1px);
    box-shadow: ${theme.boxShadow.xs}; /* KORRIGIERT */
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  svg {
    width: 14px;
    height: 14px;
  }
`;

const LoadingDot = styled.span`
  display: inline-block;
  width: 7px;
  height: 7px;
  background-color: currentColor;
  border-radius: 50%;
  opacity: 0.7;
  animation: pulse 1.5s infinite ease-in-out;

  @keyframes pulse {
    0%,
    100% {
      transform: scale(0.8);
      opacity: 0.4;
    }
    50% {
      transform: scale(1.1);
      opacity: 0.8;
    }
  }
`;

const NumberedList = styled.ol`
  margin: 0;
  padding-left: 1.5rem;
  list-style-position: outside;
`;

const ListItem = styled.li`
  margin-bottom: ${theme.spacing.md}; /* KORRIGIERT */
  line-height: 1.7;
  font-size: 1rem;
  padding-left: ${theme.spacing.sm}; /* KORRIGIERT */

  &:last-child {
    margin-bottom: 0;
  }
`;

const Paragraph = styled.p`
  margin: 0 0 ${theme.spacing.md} 0; /* KORRIGIERT */
  line-height: 1.7;
  font-size: 1rem;
  color: ${theme.colors.text};

  &:last-child {
    margin-bottom: 0;
  }
`;

const CollapsibleSection = styled.div`
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.borderRadius.lg};
  overflow: hidden;
  box-shadow: ${theme.boxShadow.sm}; /* KORRIGIERT */
  background-color: white;
`;

const CollapsibleHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.25rem 1.75rem;
  background-color: ${theme.colors.backgroundAlt};
  cursor: pointer;
  transition: background-color ${theme.transitions.fast};
  border-bottom: 1px solid
    ${({ isOpen }) => (isOpen ? theme.colors.border : "transparent")};

  &:hover {
    background-color: ${theme.colors.borderLight};
  }
`;

const CollapseIcon = styled.span`
  transition: transform ${theme.transitions.default}; /* KORRIGIERT */
  transform: ${({ isOpen }) => (isOpen ? "rotate(0deg)" : "rotate(-90deg)")};
  font-size: 1.1rem;
  color: ${theme.colors.textLight};
`;

const UsedDocumentsContent = styled.div`
  padding: 1.75rem;
`;

const DocInfoBanner = styled.div`
  background-color: ${theme.colors.infoBackground};
  border: 1px solid ${theme.colors.infoBorder};
  color: ${theme.colors.infoText};
  padding: 0.8rem 1.2rem;
  border-radius: ${theme.borderRadius.md};
  margin-bottom: ${theme.spacing.lg}; /* KORRIGIERT */
  font-size: 0.9rem;

  strong {
    font-weight: 600;
  }
`;

const DocumentTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: ${theme.spacing.md}; /* KORRIGIERT */
`;

const DocTableHeader = styled.thead`
  background-color: ${theme.colors.backgroundAlt};
  border-bottom: 2px solid ${theme.colors.border};
`;

const DocTableBody = styled.tbody``;

const DocTableRow = styled.tr`
  border-bottom: 1px solid ${theme.colors.borderLight};
  &:last-child {
    border-bottom: none;
  }
  &:nth-child(even) {
    background-color: ${theme.colors.backgroundAlt}50;
  }
  &:hover {
    background-color: ${theme.colors.primary}10;
  }
`;

const DocTableCategoryRow = styled.tr`
  background-color: ${theme.colors.primary}15 !important;
  font-weight: 600;
  color: ${theme.colors.primaryDark};
  border-top: 2px solid ${theme.colors.primary}30;
  border-bottom: 1px solid ${theme.colors.primary}30;

  td {
    padding-top: 0.8rem;
    padding-bottom: 0.8rem;
  }
`;

const CategoryIcon = styled.span`
  display: inline-flex;
  vertical-align: middle;
  margin-right: ${theme.spacing.sm}; /* KORRIGIERT */
  margin-bottom: 2px;
`;

const DocTableHeaderCell = styled.th`
  text-align: left;
  padding: 0.8rem 1.2rem;
  font-weight: 600;
  font-size: 0.9rem;
  color: ${theme.colors.heading};
`;

const DocTableCell = styled.td`
  padding: 0.8rem 1.2rem;
  font-size: 0.9rem;
  vertical-align: middle;
`;

const DocName = styled.div`
  font-family: ${theme.fonts.mono}; /* KORRIGIERT */
  word-break: break-all;
  cursor: ${({ clickable }) => (clickable ? "pointer" : "default")};
  color: ${({ clickable }) => (clickable ? theme.colors.primary : "inherit")};
  transition: color ${theme.transitions.fast};
  display: block;
  margin-bottom: 4px;
  font-weight: 500;

  &:hover {
    color: ${({ clickable }) =>
      clickable ? theme.colors.primaryDark : "inherit"};
    text-decoration: ${({ clickable }) =>
      clickable ? "underline" : "none"};
  }
`;

const DocMetaInfo = styled.div`
  font-size: 0.8rem;
  color: ${theme.colors.textLight};
  margin-top: 5px;
  line-height: 1.4;
`;

const DocRemovedInfo = styled.div`
  margin-top: ${theme.spacing.lg}; /* KORRIGIERT */
  padding: 0.8rem 1.2rem;
  background-color: ${theme.colors.warningBackground};
  border: 1px solid ${theme.colors.warningBorder};
  border-radius: ${theme.borderRadius.md};
  font-size: 0.9rem;
  color: ${theme.colors.warningText};

  strong {
    font-weight: 600;
  }
`;

const EmptyState = styled.div`
  padding: ${theme.spacing.xxl} ${theme.spacing.xl}; /* KORRIGIERT */
  text-align: center;
  color: ${theme.colors.textLight};
  background-color: ${theme.colors.backgroundAlt};
  border-radius: ${theme.borderRadius.lg};
  box-shadow: ${theme.boxShadow.sm}; /* KORRIGIERT */
  border: 1px solid ${theme.colors.borderLight};
  max-width: 600px;
  margin: ${theme.spacing.xl} auto; /* KORRIGIERT */
  font-size: 1.1rem;
`;

const JudgmentsOverviewContent = styled.div`
  padding: 1.75rem;
`;

const JudgmentList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

const JudgmentListItem = styled.li`
  background-color: white;
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.borderRadius.md};
  padding: 1.25rem 1.5rem;
  box-shadow: ${theme.boxShadow.xs}; /* KORRIGIERT */
  transition: box-shadow ${theme.transitions.fast};

  &:hover {
    box-shadow: ${theme.boxShadow.md}; /* KORRIGIERT */
  }
`;

const JudgmentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${theme.spacing.md}; /* KORRIGIERT */
  flex-wrap: wrap;
  gap: 0.75rem;
`;

const JudgmentLink = styled.a`
  font-weight: 600;
  color: ${theme.colors.primary};
  cursor: pointer;
  text-decoration: none;
  font-size: 0.95rem;
  word-break: break-all;
  transition: color ${theme.transitions.fast};

  &:hover {
    color: ${theme.colors.primaryDark};
    text-decoration: underline;
  }
`;

const JudgmentRating = styled.span`
  font-size: ${({ isInline }) => (isInline ? "0.75rem" : "0.85rem")};
  font-weight: 600;
  padding: ${({ isInline }) =>
    isInline ? "0.2rem 0.5rem" : "0.3rem 0.7rem"};
  border-radius: ${theme.borderRadius.full};
  background-color: ${({ rating }) => getRatingColor(rating)}25;
  color: ${({ rating }) => getRatingColor(rating)};
  border: 1px solid ${({ rating }) => getRatingColor(rating)}60;
  white-space: nowrap;
  flex-shrink: 0;
`;

const JudgmentSummary = styled.p`
  font-size: 0.95rem;
  line-height: 1.6;
  color: ${theme.colors.text};
  margin: 0;
`;

const MarkdownContent = styled.div`
  line-height: 1.7;
  font-size: 1rem;
  color: ${theme.colors.text};

  h1,
  h2,
  h3 {
    margin-top: ${theme.spacing.xl}; /* KORRIGIERT */
    margin-bottom: ${theme.spacing.md}; /* KORRIGIERT */
    font-weight: 600;
    color: ${theme.colors.heading};
    padding-bottom: ${theme.spacing.sm}; /* KORRIGIERT */
    border-bottom: 1px solid ${theme.colors.borderLight};
  }
  h1 {
    font-size: 1.4rem;
  }
  h2 {
    font-size: 1.2rem;
  }
  h3 {
    font-size: 1.1rem;
  }

  p {
    margin-bottom: 1.25rem;
  }

  ul,
  ol {
    margin-bottom: 1.25rem;
    padding-left: ${theme.spacing.xl}; /* KORRIGIERT */
  }

  li {
    margin-bottom: 0.75rem;
  }

  strong {
    font-weight: 600;
  }

  em {
    font-style: italic;
    color: ${theme.colors.textLight};
  }

  & > *:last-child {
    margin-bottom: 0;
  }
`;

export default AnalysisDisplay;
